module.exports = __webpack_public_path__ + "static/media/Background.166e9756.jpg";